import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { FileSizeModal } from '../../Modals/FileSizeModal.tsx';

export const i18n: {
	fileGoogleExceedsLimit: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	fileGoogleExceedsLimit: {
		id: 'import-from-sources.warning-modal.fileGoogleExceedsLimit',
		defaultMessage: '{fileName} exceeds the 10 MB export limit from Google Drive.',
		description: "Message in modal body indicating that the file's size is bigger than the limit",
	},
});

export const GoogleFileSizeModal: React.FC<{
	onSubmit: () => void;
	onClose: () => void;
	fileName: string;
}> = ({ onSubmit, onClose, fileName }) => {
	return (
		<FileSizeModal
			onSubmit={onSubmit}
			onClose={onClose}
			bodyText={
				<FormattedMessage
					{...i18n.fileGoogleExceedsLimit}
					values={{
						fileName: <b>{fileName}</b>,
					}}
				/>
			}
		/>
	);
};
